<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData" @uploadFile="uploadFile"></UPDATE>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/agent/util/url'
import DateUtil from '@/utils/dataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import UPDATE from '@/components/page/update'
import Qs from 'qs'

let statusArr = {0: '未審批', 1: '審批成功', 2: '審批失敗'}

export default {
  name: 'customerApply',
  components: {
    FORM,
    tablePage,
    UPDATE
  },

  data() {
    return {
      queryData: {},

      updateData: {
        cols: [
          {
            title: '用戶列表',
            field: 'customerNumber',
            type: 11,
            action: Url.utils.uploadFile,
            downUrl: 'https://img.forexcf.com/source/downloadModel/用户模板.xlsx',
            required: true
          },
          {title: '代理編碼', field: 'agentCode'}
        ]
      },

      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {title: '代理編碼', field: 'agentCode'},
          {title: '交易账号', field: 'customerNumber'},
          {
            title: '时间',
            field: 'time',
            type: 6,
            format: 'yyyy-MM-dd HH:mm:ss',
            startEndParam: ['startTime', 'endTime']
          },
          {
            title: '狀態',
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          {click: window.$t('common.search')},
          {click: window.$t('common.import'), auth: 'analyse:customerApply:import'}
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.customerApplyList,
        selection: false,
        sequence: false,
        method: 'get',
        cols: [

          {title: '交易账号', field: 'customerNumber'},
          {title: '代理編碼', field: 'agentCode'},
          {
            title: '上傳時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {title: '上傳人', field: 'cname'},
          {
            title: '審批時間', field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {title: '審批人', field: 'uname'},
          {
            title: '狀態', field: 'status', render: (data, full) => {
              return statusArr[data]
            }
          },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.delete'),
                click: 'delete',
                type: 'primary',
                icon: 'el-icon-delete',
                auth: 'analyse:customerApply:del'
              },
              {
                name: window.$t('common.approve'),
                click: 'approve',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'analyse:customerApply:approve', hidden: (data, full) => {
                  return full.status != 0
                }
              },
              {
                name: window.$t('common.reject'),
                click: 'reject',
                type: 'primary',
                icon: 'el-icon-reject',
                auth: 'analyse:customerApply:reject', hidden: (data, full) => {
                  return full.status != 0
                }
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    uploadFile(col, result) {
      console.info(result)
      col.data = (result || []).join(',')
    },
    submit(model) {
      this.dataChange(Url.adAgent.customerApplyImport, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    bthClick(clickName, row) {
      if (clickName == 'delete') {
        let option = {
          id: row.id
        }
        this.dataChange(Url.adAgent.customerApplyDel, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'reject' || clickName == 'approve') {
        let option = {
          id: row.id,
          status: clickName == 'approve' ? 1 : 2
        }
        this.dataChange(Url.adAgent.customerApplyStatus, option, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        data.endTime = data.endTime ? new Date(data.endTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if ('导入' == clickName || window.$t('common.import') == clickName) {
        this.$refs.childUpdate.open()
      }
    }
  },
  mounted() {
  }
}
</script>

<style>
.customerList .total_con {
  width: 96%;
  margin: 0 auto;
}

.customerList .total_con .el-form-item {
  margin: 0 30px 0 0;
}

.customerList .total_con p {
  color: #ff5500;
  font-size: 16px;
  font-weight: bolder;
}
</style>
